import React from "react";
import { ErrorPage } from "core/config/routing/pages/globalPages";

// A page that throws while rendering would otherwise unmount the whole app and leave a blank screen.
class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error(error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) return <ErrorPage />;
    return this.props.children;
  }
}

export default PageErrorBoundary;
